import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from "react-router-dom";
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Logo from '../../images/Mainlogo.png'
import List from '@material-ui/core/List';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useRedirect } from "react-admin";
import { useQueryWithStore, useAuthProvider } from "react-admin";

const useStyles = makeStyles(theme => ({
  icon: {
    marginRight: theme.spacing(2),
    height: 45,
  },
  title: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: 0
  },
  list: {
    width: 250,
  },
  purpleAvatar: {
    margin: 10,
    color: '#fff',
    backgroundColor: '#171C49',
  },
  avatar: {
    margin: 10,
    color: '#fff',
    // backgroundColor: '#171C49',
  },
}))

export default function Album(props) {
  const matches = useMediaQuery("(min-width:600px)");
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const userId = localStorage.getItem("user")
  const userData = useQueryWithStore({
    type: 'getOne',
    resource: 'User',
    payload: { id: userId }
  });

  //DEBUG
  //console.log('Logged in User Data:', JSON.stringify(userData, 0, 2))
  const Auth = useAuthProvider()
  const redirect = useRedirect()
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const toggleDrawer = (side, open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [side]: open });
  };

  if (!userData.loaded) return null
  if (userData.error) return null
  const { profileImage } = userData.data

  //console.log("User Data from the AppBar: ",JSON.stringify(userData, 0, 2))

  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List >
        <React.Fragment >
          <List >
            <ListItem button >
              <ListItemText
                primary="My Appointments"
                onClick={() => {
                  redirect("/my-appointments")
                }} />
            </ListItem>
          </List>
        </React.Fragment>
        {/* <React.Fragment>
          <List>
            <ListItem button>
              <ListItemText primary="About" />
            </ListItem>
          </List>
        </React.Fragment> */}
        <List>
          <ListItem button>
            <ListItemText
              primary="My Profile"
              onClick={() => {
                redirect("/myprofile")
              }} />
          </ListItem>
        </List>
        <List>
          <ListItem button>
            <ListItemText
              primary="My Offers"
              onClick={() => {
                redirect("/myoffers")
              }} />
          </ListItem>
        </List>
    
        <List>
          <Link style={{ textDecoration: 'none', color: "#000000", }} >
            <ListItem button>
              <ListItemText
                primary="Logout"
                onClick={() => {
                  localStorage.clear()
                  Auth.logout()
                  redirect("/login")
                }} />
            </ListItem>
          </Link>
        </List>
      </List>
    </div>
  );

  if (matches) {
    return (
      <React.Fragment>
        <CssBaseline />
        <AppBar position="fixed" style={{ background: 'white', boxShadow: 'none' }}>
          <Toolbar>
            <Link to="/" >
              <img name="image" src={Logo} alt={"123Mentor"} className={classes.icon} />
            </Link>

            <Button
              color="grey"
              style={{ marginLeft: "60%" }}
              onClick={() => {
                redirect("/my-appointments")
              }}
            >my appointments</Button>

            <div style={{ marginLeft: "4%" }}>
              <Avatar alt="123mentor" src={profileImage && profileImage !== undefined ? profileImage._url : ""} onClick={handleClick} />
              <Menu
                style={{ marginTop: "40px", marginLeft: "-6%" }}
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClose={handleClose} onClick={() => {
                  redirect("/myprofile")
                }}>My Profile</MenuItem>
                 <MenuItem onClose={handleClose} onClick={() => {
                  redirect("/myoffers")
                }}>My Offers</MenuItem>
               
                <Link style={{ textDecoration: "none", color: "black", }}>
                  <MenuItem onClose={handleClose} onClick={() => {
                    localStorage.clear()
                    Auth.logout()
                    redirect("/login")
                  }}>Logout</MenuItem></Link>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <CssBaseline />
        <AppBar style={{ boxShadow: "none" }} color="white">
          <Toolbar>
            <Link to="/">
              <img name="image" src={Logo} alt={"123Mentor"} className={classes.icon} />
            </Link>
            <Typography variant="h6" className={classes.title}>
            </Typography>

            <IconButton onClick={toggleDrawer('right', true)} edge="end" className={classes.menuButton} color="inherit" aria-label="menu">
              <MenuIcon />
            </IconButton>

            <SwipeableDrawer
              anchor="right"
              open={state.right}
              onClose={toggleDrawer('right', false)}
              onOpen={toggleDrawer('right', true)}
            >
              {sideList('right')}
            </SwipeableDrawer>

          </Toolbar>
        </AppBar>
      </React.Fragment>
    );

  }
}